<template>
  <div>
    <loader :loading="loading"/>

    <page-header :title="`Treinamentos`">
      <template v-slot:breadcrumbs>
        <li>Treinamentos</li>
      </template>

      <template v-slot:actions>
        <div>
          <button class="btn btn-success" @click="clearFields" data-bs-toggle="modal" data-bs-target="#lesson-modal">Novo Treinamento</button>
        </div>
      </template>
    </page-header>

    <filters @search="handleSearch(filters, 1)" @clear="clearFilters" margin-top="mt-5">
      <form @keyup.enter="handleSearch(filters)">
        <div class="row g-2">
          <div class="col-3">
            <label class="form-label">Produto</label>
            <select
                class="form-select form-select-sm"
                @change="filters.type = ''"
                v-model="filters.product"
            >
              <option value="">Todos</option>
              <option v-for="product in products.data" :value="product.id">{{product.name}}</option>
            </select>
          </div>

          <div class="col-3">
            <label class="form-label">Tipo</label>
            <select
                class="form-select form-select-sm"
                @change="filters.category_id =''"
                v-model="filters.type"
            >
              <option value="">Todos</option>
              <option v-for="category in filterRoot" :value="category.id">{{category.name}}</option>
            </select>
          </div>

          <div class="col-3">
            <label class="form-label">Categoria</label>
            <select
                class="form-select form-select-sm"
                v-model="filters.category_id"
            >
              <option value="">Todos</option>
              <option v-for="category in filterCategories" :value="category.id">{{category.name}}</option>
            </select>
          </div>

          <div class="col-3">
            <label class="form-label">Situação</label>
            <select
                class="form-select form-select-sm"
                v-model="filters.status"
            >
              <option value="">Todos</option>
              <option value="published">Publicado</option>
              <option value="schedule">Programado</option>
              <option value="draft">Rascunho</option>
            </select>
          </div>

          <div class="col-12">
            <div>
              <label class="form-label">Título</label>
              <input type="text" class="form-control form-control-sm" v-model="filters.title">
            </div>
          </div>
        </div>
      </form>
    </filters>

    <div class="card bg-white mt-4">
      <div class="card-body p-4">
        <div class="d-flex align-items-center justify-content-end">
          <span class="small text-secondary" v-if="collection.data.length">
            Mostrando {{ collection.data.length }} de {{ collection.meta.total }} registros
          </span>
        </div>
        <div class="table-responsive mt-3">

          <table class="table table-striped" v-if="collection.data.length">
            <thead>
            <tr>
              <th class="text-center">Ordem</th>
              <th>Título</th>
              <th class="text-center">Produto</th>
              <th class="text-center">Tipo</th>
              <th class="text-center">Categoria</th>
              <th class="text-center">Situação</th>
              <th class="text-center">Tela inicial</th>
              <th></th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="lesson in collection.data" :key="lesson.id">
              <td class="text-center">{{ lesson.order }}</td>
              <td>{{ lesson.title }}</td>
              <td class="text-center">{{ lesson.product.name }}</td>
              <td class="text-center">{{ lesson.category_object.parent.name}}</td>
              <td class="text-center">{{ lesson.category}}</td>
              <td class="text-center">
                {{ getStatus(lesson.status)}}
              </td>
              <td class="text-center">
                {{ lesson.start_screen === 1 ? 'Sim' : 'Não'}}
              </td>
              <td>
                <div class="d-flex align-items-center justify-content-end">
                  <div class="btn-group">
                    <button type="button" class="btn btn-primary btn-sm dropdown-toggle"
                            data-bs-popper-config='{"strategy":"fixed"}' data-bs-toggle="dropdown">
                      Ações
                    </button>
                    <ul class="dropdown-menu">
                      <li><a class="dropdown-item" href="#" @click.prevent="edit(lesson.id)">Editar</a></li>
                      <li><a class="dropdown-item" href="#" @click.prevent="show(lesson.id)">Exibir</a></li>
                      <li><a class="dropdown-item" href="#" @click.prevent="sort(lesson.id)">Ordenar</a></li>
                      <li><a class="dropdown-item" href="#" @click.prevent="remove(lesson.id)">Remover</a></li>
                    </ul>
                  </div>
                </div>
              </td>
            </tr>
            </tbody>
          </table>

          <div class="bg-light p-2 rounded-2 text-center" v-else>Nenhum registro encontrado...</div>

          <div class="d-flex align-items-center justify-content-center mt-4">
            <paginator
                :current-page="collection.meta.current_page"
                :limit-pages="5"
                :pages="collection.meta.last_page"
                @page-changed="handleSearch(filters, $event)"
                v-if="collection.data.length"
            />
          </div>
        </div>
      </div>
    </div>

    <modal id="lesson-modal" :custom-classes="['modal-dialog-centered', 'modal-lg']" title="Treinamento">
      <template #body>
        <div class="row g-2">

          <div class="col-4">
            <label class="form-label">Produto</label>
            <select
                class="form-select"
                @change="payload.type=''; payload.category_id = null; selectedLesson = null; lessonsType = []"
                v-model="payload.product"
                :class="{ 'is-invalid' : $v.payload.product.$error }"
            >
              <option v-for="product in products.data" v-bind:key="product.id" :value="product.id">{{product.name}}</option>
            </select>
          </div>

          <div class="col-4">
            <label class="form-label">Tipo</label>
            <select
                class="form-select"
                @change="payload.category_id = null; onChangeType()"
                v-model="payload.type"
                :class="{ 'is-invalid' : $v.payload.type.$error }"
            >
              <option v-for="category in filterRootPayload" :value="category.id">{{category.name}}</option>
            </select>
          </div>

          <div class="col-4">
            <label class="form-label">Categoria</label>
            <select
                class="form-select"
                v-model="payload.category_id"
                :class="{ 'is-invalid' : $v.payload.category_id.$error }"
            >
              <option v-for="category in categories" :value="category.id">{{category.name}}</option>
            </select>
          </div>

          <div class="col-4">
            <label class="form-label">Situação</label>
            <select
                class="form-select"
                v-model="$v.payload.status.$model"
                :class="{ 'is-invalid' : $v.payload.status.$error }"
                @change="onChangeStatus"
            >
              <option value="published">Publicado</option>
              <option value="schedule">Programado</option>
              <option value="draft">Rascunho</option>
            </select>
          </div>

          <div class="col-2">
            <label class="form-label">Tela inicial?</label>
            <select
                class="form-select"
                v-model="payload.start_screen"
                @change="payload.start_date = null; payload.end_date = null;"
            >
              <option value="1">Sim</option>
              <option value="0">Não</option>
            </select>
          </div>

          <div class="col-6" v-if="payload.status !== 'schedule'">
            <label class="form-label">Período de programação</label>
            <div class="d-flex align-items-center gap-2">
              <date-picker
                  type="date"
                  format="DD/MM/YYYY"
                  value-type="YYYY-MM-DD"
                  :disabled="payload.start_screen == 0"
                  v-model="$v.payload.start_date.$model"
                  :input-class="$v.payload.start_date.$error ? 'form-control is-invalid' : 'form-control'"
              />

              <date-picker
                  type="date"
                  format="DD/MM/YYYY"
                  value-type="YYYY-MM-DD"
                  :disabled="payload.start_screen == 0"
                  v-model="$v.payload.end_date.$model"
                  :input-class="$v.payload.end_date.$error ? 'form-control is-invalid' : 'form-control'"
              />
            </div>
          </div>

          <div class="col-3" v-if="payload.status === 'schedule'">
            <label class="form-label">Data Programada</label>
            <date-picker
                v-model="$v.payload.due_date.$model"
                type="datetime"
                :input-class="$v.payload.due_date.$error ? 'form-control is-invalid' : 'form-control'"
                format="DD/MM/YYYY HH:mm"
                value-type="YYYY-MM-DD HH:mm:ss"
                :disabled="payload.status !== 'schedule'"
            />
          </div>

          <div class="col-3" v-if="payload.status === 'schedule'">
            <label class="form-label">Senha</label>
            <input
                class="form-control"
                v-model="payload.password"
                :disabled="payload.status !== 'schedule'"
            />
          </div>

          <div class="col-12">
            <label class="form-label">Ordem</label>
            <select
                class="form-select"
                :class="{ 'is-invalid' : $v.selectedLesson.$error }"
                v-model="$v.selectedLesson.$model"
              >
              <option
                v-for="lesson in lessonsType"
                :value="lesson"
              >
              {{ lesson.title }}
              </option>
            </select>
          </div>

          <div class="col-12">
            <label class="form-label">Título</label>
            <input
                class="form-control"
                v-model="$v.payload.title.$model"
                :class="{ 'is-invalid' : $v.payload.title.$error }"
            />
          </div>

          <div class="col-8">
            <label class="form-label">Descrição</label>
            <textarea
                class="form-control"
                style="height: 150px"
                v-model="$v.payload.content.$model"
                :class="{ 'is-invalid' : $v.payload.content.$error }"
            >

            </textarea>
          </div>

          <div class="col-4">
            <label class="form-label">Imagem de capa</label>
            <input
                type="file"
                class="form-control form-control-sm d-none"
                accept="image/*"
                ref="file"
                @change="onFileChange"
            >
            <div
                class="border border-2 border-primary rounded-3 cursor-pointer position-relative"
                :class="{'p-2' : preview}"
                @click.prevent="$refs.file.click()"
            >
              <img
                  :src="preview ? preview : `https://placehold.co/243x148/f8f9fa/6769f0/?text=Capa`"
                  class="rounded-3 border-info cursor-pointer"
                  width="100%"
              />
              <button
                  v-if="preview"
                  type="button"
                  class="btn btn-danger btn-sm p-1 lh-1 position-absolute bottom-0 end-0 m-2"
                  title="Remover imagem"
                  @click.stop.prevent="removeThumbnail"
              >
                <i class="la la-trash" />
              </button>
            </div>
          </div>

          <div class="col-12">
            <label class="form-label">Manual</label>
            <input type="file" class="d-none" ref="uploadFile" @change="handleFileUpload" />
            <div class="input-group">
              <input
                  type="text"
                  class="form-control"
                  :class="{ 'is-invalid': $v.payload.file_url.$error }"
                  readonly
                  :value="uploadedFile ? uploadedFile.name : (payload.file_url || '')"
                  placeholder="Nenhum arquivo selecionado"
              />
              <button
                  v-if="uploadedFile || payload.file_url"
                  class="btn btn-outline-danger"
                  type="button"
                  @click.prevent="removeFile"
                  title="Remover arquivo"
              >
                <i class="la la-trash la-2x" />
              </button>
              <button class="btn btn-outline-primary" type="button" @click.prevent="$refs.uploadFile.click()" :title="uploadedFile || payload.file_url ? 'Trocar arquivo' : 'Selecionar arquivo'">
                <i :class="'la la-file-upload la-2x'" />
              </button>
              <button
                  class="btn btn-outline-dark"
                  type="button"
                  :disabled="!uploadedFile && !payload.file_url"
                  @click.prevent="openFilePreview"
                  title="Visualizar arquivo"
              >
                <i class="la la-external-link la-2x" />
              </button>
            </div>
            <div class="invalid-feedback d-block" v-if="$v.payload.file_url.$error">{{ fileUrlErrorMessage }}</div>
          </div>

          <div class="col-12">
            <label class="form-label">Url do Vídeo</label>
            <div class="input-group">
              <input
                  class="form-control"
                  v-model="$v.payload.media_url.$model"
                  :class="{ 'is-invalid' : $v.payload.media_url.$error }"
                  placeholder="Nenhuma url adicionada"
              />
              <button
                  class="btn btn-outline-dark"
                  type="button"
                  :disabled="!payload.media_url"
                  @click.prevent="openMediaUrl"
                  title="Visualizar vídeo"
              >
                <i class="la la-external-link la-2x" />
              </button>
            </div>
            <div class="invalid-feedback d-block" v-if="$v.payload.media_url.$error">{{ mediaUrlErrorMessage }}</div>
          </div>

        </div>
      </template>

      <template #footer>
        <button type="button" class="btn btn-danger" data-bs-dismiss="modal">Cancelar</button>
        <button type="button" class="btn btn-primary" @click.prevent="handleSave">Salvar</button>
      </template>
    </modal>

    <modal id="sort-modal" :custom-classes="['modal-dialog-centered', 'modal-lg']" title="Ordenar Treinamento">

      <template #body>

        <div>
          <label class="form-label">Título</label> 
          <input type="text" class="form-control form-control-sm" v-model="payload.title">
        </div>

        <div class="mt-4">
          <label class="form-label">Ordenar</label>
        </div>
        <div class="d-flex gap-3">
          <div class="form-check">
            <input class="form-check-input" type="radio" name="flexRadio" id="before" value="before" v-model="selectedOption">
            <label class="small form-check-label" for="before">
              Antes
            </label>
          </div>
          <div class="form-check">
            <input class="form-check-input" type="radio" name="flexRadio" id="after" value="after" v-model="selectedOption">
            <label class="small form-check-label" for="after">
              Depois
            </label>
          </div>
        </div>
        <div v-if="$v.selectedOption.$error" class="invalid-feedback d-block">Campo Obrigatório!</div>

        
        <div class="col-12 col-lg-12 mt-4">
          <form-select
            :options="lessonsType"
            :searchable="true"
            search-placeholder="Buscar Treinamento"
            label="Buscar"
            v-model.trim="$v.selectedLesson.$model"
            :class="{ 'form--error': $v.selectedLesson.$error }"
            @update="updateLesson"
            :async="true"
            placeholder="Selecione"
            :has-actions="true"
            @search="getLessons($event)"
            key-name="id"
          >
          <template v-slot:no-data="slotProps">
            <div class="d-flex align-items-center justify-content-center flex-column" v-if="slotProps.search">
              <div class="d-flex align-items-center justify-content-center text-center">
                <p>Não encontramos nenhum resultado <br/></p>
              </div>
            </div>
          </template>
        </form-select>
        <div v-if="$v.selectedLesson.$error" class="invalid-feedback d-block">Campo Obrigatório!</div>
      </div>

      
      </template>

      <template #footer>
        <button type="button" class="btn btn-danger" data-bs-dismiss="modal">Cancelar</button>
        <button type="button" class="btn btn-primary" @click.prevent="saveSortModal">Salvar</button>
      </template>
    </modal>

    <modal id="pages-modal" :custom-classes="['modal-dialog-centered', 'modal-lg', 'modal-dialog-scrollable']" title="Exibir em páginas">
      <template #body>
        <div class="mb-3">
          Exibir "{{ payload.title }}" nas páginas de:
        </div>
        <div class="row">
          <div class="col-12">
            <div class="card-title text-primary mb-2">
              Páginas Principais
            </div>
            <div class="row">
              <div class="col-4" v-for="page in otherPages" :key="page.id">  
                <div class="form-check">
                  <input class="form-check-input" type="checkbox" :value="page.id" v-model="selectedPages">
                  <label class="form-check-label">
                    {{ page.name }}
                  </label>
                </div>
              </div>
          </div>
          </div>
          <div class="col-12 mt-3">
            <div class="card-title text-primary mb-2">
              Páginas de Cadastro
            </div>
            <div class="row">
              <div class="col-6" v-for="page in pagesRegister" :key="page.id">  
                <div class="form-check">
                  <input class="form-check-input" type="checkbox" :value="page.id" v-model="selectedPages">
                  <label class="form-check-label">
                    {{ page.name }}
                  </label>
                </div>
              </div>
            </div>
          </div>
          <div class="col-12 mt-3">
            <div class="card-title text-primary mb-2">
              Modais
            </div>
            <div class="row">
              <div class="col-6" v-for="page in pagesModal" :key="page.id">  
                <div class="form-check">
                  <input class="form-check-input" type="checkbox" :value="page.id" v-model="selectedPages">
                  <label class="form-check-label">
                    {{ page.name }}
                  </label>
                </div>
              </div>
            </div>
          </div>
        </div>

      </template>
      <template #footer>
        <button type="button" class="btn btn-primary" @click.prevent="saveLessonPages">Salvar</button>
      </template>
    </modal>

  </div>
</template>
<script>
import {mapActions, mapState} from "vuex";
import PageHeader from "@/components/PageHeader.vue";
import Paginator from "@/components/shared/paginator.vue";
import Loader from "@/components/shared/loader.vue";
import Filters from "@/components/shared/Filters.vue";
import axios from "axios";
import Modal from "@/components/shared/Modal.vue";
import {Modal as bsModal} from "bootstrap";
import {required, requiredIf, url} from "vuelidate/lib/validators";
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import lodash from "lodash";

import 'vue2-datepicker/locale/pt-br';
import FormSelect from "../../components/shared/formSelect.vue";

export default {
  props: {},
  components: {
    Modal,
    Filters,
    Loader,
    Paginator,
    PageHeader,
    DatePicker,
    FormSelect
  },
  data() {
    return {
      lessonsType: [],
      selectedLesson: null,
      originalSelectedLesson: null,
      editing: false,
      loading: false,
      selectedOption: null,
      filters: {
        title: null,
        type: '',
        category_id: '',
        status: '',
        product: ''
      },
      modal: null,
      modalSort: null,
      modalPages: null,
      preview: null,
      thumbnailRemoved: false,
      uploadedFile: null,
      uploadedFilePreviewUrl: null,
      payload: {
        start_screen: 0,
        start_date: null,
        end_date: null,
        type: null,
        category_id: null,
        title: null,
        content: null,
        media_url: null,
        thumbnail: null,
        status: 'draft',
        order: 1,
        due_date: null,
        password: null,
        product: null,
        file_url: null,
      },
      pages: [
        {id: '/central-notificacoes', name: 'Central de notificações'},
        {id: '/navbar', name: 'Início'},
        {id: '/imoveis', name: 'Imóveis'},
        {id: '/imoveis/add', name: 'Cadastro de Imóvel'},
        {id: 'editPhotos', name: 'Editar Fotos'},
        {id: 'addVideo', name: 'Adicionar Vídeo'},
        {id: 'add360', name: 'Adicionar 360°'},
        {id: '/condominios', name: 'Edifícios e Condomínios'},
        {id: '/condominios/add', name: 'Cadastro de Edifícios/Condomínios'},
        {id: '/pessoas', name: 'Pessoas'},
        {id: '/pessoas/add', name: 'Cadastro de Pessoas'},
        {id: '/crm/funil-vendas', name: 'Funil de vendas'},
        {id: 'crm-funil-termometro', name: 'Termômetro'},
        {id: '/crm/base-leads', name: 'Base de Leads'},
        {id: '/crm/base-leads/add', name: 'Cadastro de Leads'},
        {id: 'crm-perfil-de-interesse', name: 'Perfil de interesse'},
        {id: '/crm/funil', name: 'Kanban de Atendimentos'},
        {id: '/crm/radar', name: 'Radar Cliente X Imóveis'},
        {id: '/crm/agenda', name: 'Agenda'},
        {id: 'crm-adicionar-atividade', name: 'Adicionar atividade'},
        {id: '/crm/leads', name: 'Roleta de Leads'},
        {id: 'crm-novo-atendimento', name: 'Novo Atendimento'},
        {id: 'crm-dados-do-atendimento', name: 'Dados do Atendimento'},
        {id: '/crm/origens', name: 'Origens de Atendimento'},
        {id: '/crm/motivos-perda', name: 'Motivos de Perda'},
        {id: '/crm/metas', name: 'Metas'},
        {id: '/crm/tags', name: 'Tags'},
        {id: '/destaques', name: 'Destaques'},
        {id: '/visitas', name: 'Chaves'},
        {id: '/propostas', name: 'Propostas'},
        {id: '/propostas/add', name: 'Cadastro de Proposta'},
        {id: '/analise-locacao', name: 'Análises de Locação'},
        {id: '/analise-locacao/add', name: 'Cadastro de Análise de Locação'},
        {id: '/financas/recibos', name: 'Recibos'},
        {id: '/financas/recibos/add', name: 'Cadastro de Recibo'},
        {id: '/relatorios/imoveis/completo', name: 'Relatórios de Imóveis'},
        {id: 'columnsReport', name: 'Montagem de Colunas'},
        {id: '/dashboard', name: 'Dashboard'},
        {id: '/bairros', name: 'Bairros'},
        {id: '/portais', name: 'Portais'},
        {id: '/portais/imoveis', name: 'Destaques para o Portal'},
        {id: '/portais/historico', name: 'Histórico de cargas'},
        {id: '/portais/add', name: 'Cadastro de Portais'},
        {id: '/roletas/add', name: 'Cadastro de Roletas'},
        {id: '/roletas/configuracao', name: 'Configuração de Roletas'},
        {id: '/quadro-chaves', name: 'Quadro de Chaves'},
        {id: '/quadro-chaves/add', name: 'Cadastro de Quadro de Chaves'},
        {id: '/parametros', name: 'Parâmetros'},
        {id: '/roletas', name: 'Roletas'},
        {id: '/documentos', name: 'Modelos de Documento'},
        {id: '/documentos/add', name: 'Cadastro de Modelos de Documento'},
        {id: '/vagas-emprego', name: 'Vagas de Emprego'},
        {id: '/vagas-empreg/add', name: 'Cadastro de Vagas de Emprego'},
        {id: '/vagas-emprego/candidaturas', name: 'Candidaturas'},
        {id: '/integracao-leads', name: 'Integração de Leads'},
        {id: '/temporada', name: 'Temporada'},
        {id: 'cadastrar-periodos-de-temporada', name: 'Cadastrar períodos de temporada'},
        {id: 'enviar-leads-para-roleta', name: 'Enviar leads para a roleta'},
        {id: 'adicionar-usuarios-roleta', name: 'Adicionar usuários na roleta'},
        {id: '/usuarios', name: 'Usuários'},
        {id: '/usuarios/add', name: 'Cadastro de Usuários'},
        {id: '/equipes', name: 'Equipes'},
        {id: '/equipes/add', name: 'Cadastro de Equipes'},
        {id: '/cargos', name: 'Cargos'},
        {id: '/perfis', name: 'Perfis de Acesso'},
        {id: '/perfis/add', name: 'Cadastro de Perfis de Acesso'},
        {id: 'updateData', name: 'Atualizar Dados'},
        {id: 'changePassword', name: 'Alterar Senha'},
        {id: 'preferences', name: 'Preferências do Usuário'},
        {id: 'changeCompany', name: 'Selecionar Empresa'},
        {id: 'mais-filtros/imoveis', name: 'Mais Filtros (Imóveis)'},
        {id: 'mais-filtros/pessoas', name: 'Mais Filtros (Pessoas)'},
        {id: 'mais-filtros/crm/base-leads', name: 'Mais Filtros (Base de Leads)'},
        {id: 'mais-filtros/visitas', name: 'Mais Filtros (Chaves emprestadas)'},
        {id: 'mais-filtros/visitas/reservas', name: 'Mais Filtros (Chaves reservadas)'},
        {id: 'mais-filtros/propostas', name: 'Mais Filtros (Proposta)'},
        {id: 'mais-filtros/analise-locacao', name: 'Mais Filtros (Análise)'},
      ],
      selectedPages: [],
    }
  },
  validations() {
    return {
      payload: {
        type: {required},
        product: {required},
        category_id: {required},
        title: {required},
        content: {
          requiredContent: function(val) {
            if (this.payload.status === 'draft') return true;
            if (!this.selectedCategory?.description_required) return true;
            return !!val;
          }
        },
        media_url: {
          mediaOrFile: function(val) {
            if (this.payload.status === 'draft') return true;
            const mr = this.selectedCategory?.media_required;
            if (mr === 'video' || mr === 'video_and_manual') {
              return !!val;
            }
            if (mr === 'video_or_manual') {
              return !!(val || this.payload.file_url || this.uploadedFile);
            }
            return true;
          },
          url
        },
        file_url: {
          mediaOrFile: function(val) {
            if (this.payload.status === 'draft') return true;
            const mr = this.selectedCategory?.media_required;
            if (mr === 'manual' || mr === 'video_and_manual') {
              return !!(val || this.uploadedFile);
            }
            if (mr === 'video_or_manual') {
              return !!(val || this.payload.media_url || this.uploadedFile);
            }
            return true;
          }
        },
        status: {required},
        order: { required },
        due_date: {
          required: requiredIf(function() {
            return this.payload.status === 'schedule';
          })
        },
        start_date: {
          required: requiredIf(function() {
            return this.payload.start_screen === '1' && this.payload.status === 'published';
          })
        },
        end_date: {
          required: requiredIf(function() {
            return this.payload.start_screen === '1' && this.payload.status === 'published';
          })
        }
      },
      selectedLesson: { required: requiredIf(function() {
        return this.modal._element.classList.contains('show') ||
               this.modalSort._element.classList.contains('show');
      })},
      selectedOption: { required: requiredIf(function() {
        return this.modalSort._element.classList.contains('show');         
      })},
      lessonsType: { required : requiredIf(function() {
        return this.modal._element.classList.contains('show');
      })},
    }
  },
  watch: {
    'payload.category_id'() {
      if (this.$v.$anyDirty) {
        this.$v.payload.content.$touch();
        this.$v.payload.media_url.$touch();
        this.$v.payload.file_url.$touch();
      }
    }
  },
  async mounted() {
    this.loading = true;
    await this.getRoot();
    await this.handleSearch(this.filters, this.$route.query.page ?? 1);
    await this.getAllProducts();
    this.modal = bsModal.getOrCreateInstance(document.getElementById('lesson-modal'));
    this.modalSort = bsModal.getOrCreateInstance(document.getElementById('sort-modal'));
    this.modalPages = bsModal.getOrCreateInstance(document.getElementById('pages-modal'));
  },
  methods: {
    ...mapActions('Lessons', ['getAll']),
    ...mapActions('Products', {getAllProducts : 'getAll'}),
    ...mapActions('LessonsCategories', ['getRoot']),
    handleFileUpload(event) {
      const file = event.target.files[0];
      if (!file) return;
      if (this.uploadedFilePreviewUrl) URL.revokeObjectURL(this.uploadedFilePreviewUrl);
      this.uploadedFile = file;
      this.uploadedFilePreviewUrl = URL.createObjectURL(file);
      event.target.value = '';
    },
    removeUploadedFile() {
      if (this.uploadedFilePreviewUrl) URL.revokeObjectURL(this.uploadedFilePreviewUrl);
      this.uploadedFile = null;
      this.uploadedFilePreviewUrl = null;
      if (this.$refs.uploadFile) this.$refs.uploadFile.value = null;
    },
    removeFile() {
      this.removeUploadedFile();
      this.payload.file_url = null;
    },
    openFilePreview() {
      const url = this.uploadedFile ? this.uploadedFilePreviewUrl : this.payload.file_url;
      if (url) window.open(url, '_blank');
    },
    openMediaUrl() {
      let url = this.payload.media_url;
      if (!url) return;
      if (url.includes('vimeo.com')) {
        let videoId = url.split('/')[3];
        videoId = videoId.split('?')[0];
        url = `https://player.vimeo.com/video/${videoId}`;
      }
      window.open(url, '_blank');
    },
    getStatus(status) {
     const data = {
       published: 'Publicado',
       draft: 'Rascunho',
       schedule: 'Programado'
     }
     return data[status];
    },
    getLessons: lodash.debounce(async function (evt) {
      let params = {
          title: evt,
          type: this.payload.type,
          id: this.payload.id
      };

      await axios.get("/admin/lessons/sort", { params }).then(response => {
          this.lessonsType = response.data.data.map(item => {
            return {
                id: item.id,
                name: item.title
            }
          });
      });
    }, 500),
    async onChangeType() {
      this.selectedLesson = null;
      this.lessonsType = [];

      const params = {
        type: this.payload.type,
        id: this.payload.id,
        product_id: this.payload.product
      };

      try {
        const response = await axios.get("/admin/lessons/sort/", { params });
        const data = response.data.data;

        if(!data.length) {
          this.lessonsType = [{
            id: null,
            title: 'Primeiro',
            order: 0,
            action: 'before'
          }];
          return;
        }

        this.lessonsType = data.map(item => {
          return {
            id: item.id,
            title: 'Depois de ' + item.title,
            rawTitle: item.title,
            order: item.order,
            action: 'after'
          };
        });

        this.lessonsType.unshift({
          id: this.lessonsType[0].id ?? null,
          title: 'Primeiro',
          order: 0,
          action: 'before'
        });

        if (!this.editing && this.payload.type) {
          this.selectedLesson = this.lessonsType[this.lessonsType.length - 1];

          this.payload.content = 'Texto';

          const mediaUrls = {
            '23d915ac-07a4-44e9-b269-90939d1e6023': 'https://sistemasgl.com.br/',
            'cb363dfa-b6b3-4f9d-ade8-cad28e973938': 'https://subsee.com.br/',
          };

          this.payload.media_url = mediaUrls[this.payload.product] ?? null;

          const lastItem = data[data.length - 1];
          const lessonResponse = await axios.get(`/admin/lessons/${lastItem.id}`);
          this.payload.category_id = lessonResponse.data.lesson_category_id;
        }
      } catch (error) {

      }
    },
    updateLesson(lesson) {
      this.payload.lesson = lesson.id;
    },
    clearFields() {
      this.payload = {
        type: null,
        category_id: null,
        title: null,
        content: null,
        media_url: null,
        file_url: null,
        thumbnail: null,
        status: 'draft',
        order: 1,
        due_date: null,
        password: null,
        start_screen: 0,
        start_date: null,
        end_date: null,
        product: null,
      }
      this.preview = null;
      this.thumbnailRemoved = false;
      this.uploadedFile = null;
      this.uploadedFilePreviewUrl = null;
      if (this.$refs.file) this.$refs.file.value = '';
      if (this.$refs.uploadFile) this.$refs.uploadFile.value = '';
      this.selectedLesson = null;
      this.originalSelectedLesson = null;
      this.lessonsType = [];
      this.editing = false;
      this.$v.$reset();
    },
    onFileChange(e) {
      const file = e.target.files[0];
      if (!file) return;
      this.payload.thumbnail = null;
      this.preview = null;
      this.preview = URL.createObjectURL(file);
      this.payload.thumbnail = file;
      e.target.value = '';
    },
    removeThumbnail() {
      this.preview = null;
      this.payload.thumbnail = null;
      this.thumbnailRemoved = true;
      if (this.$refs.file) this.$refs.file.value = '';
    },
    async handleSearch(filters, page = 1) {
      this.loading = true;
      const params = {
        page: page,
        ...filters
      }

      await this.getAll(params).finally(() => {
        this.loading = false;
        this.$scrollTop();
      });

      this.$urlUtils.assignQueryString(this.$route, params);
    },
    clearFilters(clean = true, page = 1) {

      if(clean) {
        this.filters = {
          title: null,
          type: '',
          category_id: '',
          status: '',
          product: ''
        }
      }

      this.handleSearch(this.filters, page);
    },
    setData(data){
      this.payload.id = data.id;
      this.payload.type = data.category.parent.id;
      this.payload.category_id = data.lesson_category_id;
      this.payload.title = data.title;
      this.payload.content = data.content;
      this.payload.media_url = data.media_url;
      this.payload.file_url = data.file_url || null;
      this.payload.status = data.status;
      this.payload.order = data.order;
      this.payload.due_date = data.due_date;
      this.preview = data.thumbnail_url;
      this.payload.password = data.password;
      this.payload.start_screen = data.start_screen === 0 ? '0' : '1';
      this.payload.start_date = data.start_date;
      this.payload.end_date = data.end_date;
      this.payload.product = data.product.id;
      this.uploadedFile = null;
      this.uploadedFilePreviewUrl = null;
      this.thumbnailRemoved = false;
      if (this.$refs.uploadFile) this.$refs.uploadFile.value = null;
    },
    async edit(id) {
      this.loading = true;
      this.editing = true;

      try {
        const response = await axios.get(`/admin/lessons/${id}`);
        const { data } = response;
        this.setData(data);

        await this.onChangeType();
        
        const currentOrder = this.payload.order;
        const currentTitle = this.payload.title;
        const prevItems = this.lessonsType.filter(item =>
          item.order < currentOrder ||
          (item.order === currentOrder && item.rawTitle < currentTitle)
        );
        this.selectedLesson = prevItems.length > 0
          ? prevItems[prevItems.length - 1]
          : this.lessonsType[0];
        this.originalSelectedLesson = this.selectedLesson;
        this.modal.show();
      } finally {
        this.loading = false;
      }
    },
    async show(id) {
      this.loading = true;

      try {
        const response = await axios.get(`/admin/lessons/${id}/pages`);
        this.selectedPages = response.data.pages;
        this.payload.title = response.data.title;
        this.payload.id = response.data.lesson_id;
        this.modalPages.show();
      } finally {
        this.loading = false;
      }
    },
    async sort(id) {
      this.loading = true;
      this.clearFields();
      await axios.get(`/admin/lessons/${id}`).then(response => {
        const { data } = response;
        this.setData(data);
        this.modalSort.show();
        this.getLessons();
      });

      this.loading = false;
    },
    async handleSave() {
      this.$v.$touch();
      if(this.$v.$invalid) {
        return false
      }

      this.loading = true;
      const data = this.$serialize(this.payload);
      if (this.uploadedFile) {
        data.append('file', this.uploadedFile);
      }
      if (this.thumbnailRemoved) {
        data.append('remove_thumbnail', '1');
      }
      let url = '/admin/lessons'
      if(this.payload.id) {
        url = `/admin/lessons/${this.payload.id}`;
        data.append('_method', 'PUT');
      }
      
      try {
        const response = await axios.post(url, data);

        this.payload.id = this.payload.id ? this.payload.id : response.data.id;

        const orderChanged = this.selectedLesson?.id !== this.originalSelectedLesson?.id
          || this.selectedLesson?.action !== this.originalSelectedLesson?.action;
        if (this.editing === false || orderChanged) {
          const sorted = await this.handleSorting();
          if (!sorted) return;
        }

        const page = this.editing ? this.collection.meta.current_page : 1;
        const scrollContainer = document.querySelector('.main-content');
        const savedScroll = this.editing ? scrollContainer?.scrollTop : 0;
        await this.handleSearch(this.filters, page);
        if (this.editing && savedScroll) {
          await this.$nextTick();
          scrollContainer.scrollTo(0, savedScroll);
        }
        this.modal.hide();
        this.clearFields();
      } catch (error) {
        this.$swal({
          icon: 'error',
          text: error?.response?.data?.message || 'Ocorreu um erro ao salvar o treinamento.'
        });
      } finally {
        this.loading = false;
      }
    },
    async handleSaveSorting(id) {
      this.loading = true;
      const page = this.collection.meta.current_page;
      const scrollContainer = document.querySelector('.main-content');
      const savedScroll = scrollContainer?.scrollTop ?? 0;

      try {
        const response = await axios.get(`/admin/lessons/${id}`);
        this.setData(response.data);
        const success = await this.handleSorting();
        if (!success) return;

        await this.handleSearch(this.filters, page);
        if (savedScroll) {
          await this.$nextTick();
          scrollContainer.scrollTo(0, savedScroll);
        }
      } finally {
        this.loading = false;
      }
    },
    async handleSorting() {
      this.$v.$touch();
      if (this.$v.$invalid) return false;

      const lastLesson = this.lessonsType[this.lessonsType.length - 1];
      const data = {
        selected_lesson_id: this.payload.id,
        reference_lesson_id: this.selectedLesson.id ? this.selectedLesson.id : this.selectedLesson,
        option: this.selectedLesson.action ? this.selectedLesson.action : this.selectedOption,
        last_order: this.editing ? null : (lastLesson?.order ?? null)
      };

      await axios.put('/admin/lessons/sort', data);
      return true;
    },
    async saveSortModal() {
      this.loading = true;
      const page = this.collection.meta.current_page;
      const scrollContainer = document.querySelector('.main-content');
      const savedScroll = scrollContainer?.scrollTop ?? 0;

      try {
        const success = await this.handleSorting();
        if (!success) return;

        this.modalSort.hide();
        this.clearFields();
        await this.handleSearch(this.filters, page);
        if (savedScroll) {
          await this.$nextTick();
          scrollContainer.scrollTo(0, savedScroll);
        }
      } finally {
        this.loading = false;
      }
    },
    async remove(id) {
      await this.$swal.fire({
        text: 'Confirma a exclusão do registro selecionado?',
        showDenyButton: true,
        confirmButtonText: 'Sim',
        denyButtonText: `Não`,
        allowOutsideClick: false
      }).then(async (result) => {
        if (result.isConfirmed) {
          this.loading = true;
          await axios.delete(`/admin/lessons/${id}`).then(() => {
            this.clearFilters(false)
          }).catch(() => {
            this.$swal({
              icon: 'error',
              text: 'Ocorreu um erro ao excluir esse treinamento'
            })
          }).finally(() => {
            this.loading = false;
          })
        }
      });
    },
    async onChangeStatus() {
      this.payload.due_date = null;
      this.payload.password = null;

      await this.$nextTick();

      if(this.payload.status === 'schedule') {
        this.payload.start_date = null;
        this.payload.end_date = null;
        this.payload.start_screen = 0;
      }
    },
    saveLessonPages() {
      let paths = this.selectedPages;
      axios.post(`/admin/lessons/${this.payload.id}/pages`, {paths}).then(response => {
        this.modalPages.hide();
      }).catch(error => {
        this.$swal({
          icon: 'error',
          text: 'Ocorreu um erro ao salvar as páginas do treinamento'
        });
      });
    },
  },
  computed: {
    ...mapState('Lessons', ['collection']),
    ...mapState('Products', { products: 'collection'}),
    ...mapState('LessonsCategories', ['root']),
    categories() {
      if(!this.payload.type) {
        return [];
      }

      return this.root.find(item => item.id === this.payload.type && item.product_id === this.payload.product).categories
    },
    selectedCategory() {
      return this.categories.find(c => c.id === this.payload.category_id) ?? null;
    },
    mediaUrlErrorMessage() {
      const mr = this.selectedCategory?.media_required;
      if (mr === 'video_or_manual') return 'Informe a URL do vídeo ou faça upload do manual';
      return 'Informe a URL do vídeo';
    },
    fileUrlErrorMessage() {
      const mr = this.selectedCategory?.media_required;
      if (mr === 'video_or_manual') return 'Adicione um manual ou informe a URL do vídeo';
      return 'Adicione um manual';
    },
    filterCategories() {
      if(!this.filters.type) {
        return this.root.filter(item => item.product_id === this.filters.product).flatMap(item => item.categories);
      }

      return this.root.find(item => item.id === this.filters.type).categories
    },
    filterRoot() {
      if(!this.filters.product) {
        return [];
      }

      return this.root.filter(item => item.product_id === this.filters.product);
    },
    filterRootPayload() {

      if(!this.payload.product) {
        return [];
      }

      return this.root.filter(item => item.product_id === this.payload.product);
    },
    pagesRegister(){
      return this.pages.filter(page => {
        return page.id.includes('/add') || page.id.includes('/edit');
      });
    },
    pagesModal(){
      return this.pages.filter(page => {
        return !page.id.includes('/') || page.id.includes('mais-filtros');
      });
    },
    otherPages(){
      return this.pages.filter(page => {
        return !this.pagesRegister.includes(page) && !this.pagesModal.includes(page);
      });
    }
  }
}
</script>
<style lang="scss">
.mx-datepicker {
  width: initial !important;
}

</style>


